/* eslint jsx-a11y/anchor-has-content: 0 */
/* eslint react/button-has-type: 0 */
import React from 'react';
import { Link } from 'gatsby';
import s from './button.module.scss';

export default function Button({
  href,
  native,
  children,
  className,
  secondary,
  big,
  small,
  type,
  html,
  reg,
  white,
  ...props
}) {
  const secondaryClasses = secondary ? s.secondary : '';
  const bigClass = big ? s.big : '';
  const smallClass = small ? s.small : '';
  const sizeClasses = bigClass || smallClass;
  const classes = `${s.default} ${className || ''} ${secondaryClasses} ${sizeClasses} ${
    reg ? s.reg : ''
  } ${white ? s.white : ''}`;

  const buttonProps = html
    ? {
        ...props,
        dangerouslySetInnerHTML: { __html: html }
      }
    : {
        ...props,
        children
      };

  if (href && native) {
    return <a className={classes} href={href} {...buttonProps} />;
  }
  if (href) {
    return <Link {...buttonProps} to={href} className={classes} />;
  }
  return <button type={type || 'button'} {...buttonProps} className={classes} />;
}
